import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import Delo from "../../img/organizers/delo.svg";
import Mmr from "../../img/organizers/mmr.svg";
import Top from "../../img/organizers/top100.svg";
import Womo from "../../img/organizers/womo.svg";
import Ekonomika from "../../img/organizers/Logo_Ekonomika.svg";

import Get from "../../img/organizers/get.svg";
import Hrws from "../../img/organizers/hrws.svg";
import Prmrfn from "../../img/organizers/prmrfn.svg";
import She from "../../img/organizers/she.png";
import Bws from "../../img/organizers/bws.svg";
import Mrktng from "../../img/organizers/mrktng.svg";

import BlockBg from "../../img/organizers/block-bg.svg";
import TopLeftBg from "../../img/organizers/block-top-left.svg";
import TopRightBg from "../../img/organizers/block-top-right.svg";
import BottomLeftBg from "../../img/organizers/block-bottom-left.svg";
import BottomRightBg from "../../img/organizers/block-bottom-right.svg";

import WhiteKubLeft from "../../img/organizers/white-kub-left.svg";
import WhiteKubRight from "../../img/organizers/white-kub-right.svg";


import 'animate.css';


const EventOrganizers = () => {
    return (
        <section className="relative z-30 py-[70px] md:py-[120px] mb-[60px] md:mb-[120px] bg-[#F4F4F4]">
            <div className="container max-w-screen-xl mx-auto px-[15px]">

                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="font-bold uppercase text-3xl text-center text-[#245864] mb-10
                        sm:text-4xl lg:text-[60px] md:mb-24">Організатори</h2>
                </ScrollAnimation>

                <div className="grid grid-cols-2 gap-x-[5px] lg:gap-x-20 mb-11 md:mb-16 lg:mb-24">

                    {/* ЛЕВЫЙ ВЕРХ */}
                    <div className="md:flex">
                        <img src={BlockBg} alt="img" className="hidden md:block h-[150px] xl:h-[228px] -mr-[1px]" />
                        <a href="https://delo.ua" target="_blank" rel="noopener noreferrer"
                            className="bg-[#245864] relative text-white flex flex-col gap-[5px] pt-4 pl-6 h-[150px] mb-[5px]
                            md:flex-1 md:pl-10 md:pt-6 xl:items-center xl:justify-center xl:p-0 xl:h-[228px] xl:gap-4">
                            <img src={Delo} alt="delo.ua" className="w-16 lg:w-32" />
                            <p className="text-[10px] xl:text-right xl:text-base">
                                лідер ділового <br /> контенту Delo.ua
                            </p>
                            <img src={TopLeftBg} alt="img" className="w-24 h-16 absolute bottom-0 left-0 md:hidden" />
                        </a>
                    </div>
                    {/* ЛЕВЫЙ ВЕРХ END */}

                    {/* ПРАВЫЙ ВЕРХ */}
                    <div className="md:flex ">
                        <a href="https://mmr.ua" target="_blank" rel="noopener noreferrer"
                            className="bg-[#245864] relative text-white flex flex-col gap-[5px] pt-4 pl-7 h-[150px] mb-[5px]
                            md:flex-1 md:items-end md:pr-10 md:pt-6 xl:items-center xl:justify-center xl:p-0 xl:h-[228px] xl:gap-4">
                            <img src={Mmr} alt="MMR.ua" className="w-20 lg:w-32" />
                            <p className="text-[10px] xl:text-base">
                                онлайн-медіа про PR <br /> та маркетинг MMR.ua
                            </p>
                            <img src={TopRightBg} alt="img" className="w-24 h-16 absolute bottom-0 right-0 md:hidden" />
                        </a>
                        <img src={BlockBg} alt="img" className="hidden md:block md:rotate-180 h-[150px] xl:h-[228px] -ml-[1px]" />
                    </div>
                    {/* ПРАВЫЙ ВЕРХ END */}


                    {/* CENTER BLOCK */}
                        <div class="col-span-2 flex items-center justify-center -mt-20 -mb-20 lg:-mb-24 lg:-mt-24  xl:-mt-28 xl:-mb-28">
                            <div className="relative z-10 rounded-full w-40 h-40 flex items-center justify-center 
                                md:w-52 md:h-52 lg:w-[280px] lg:h-[280px] xl:w-[336px] xl:h-[336px]
                                bg-[linear-gradient(120deg,#B43125_0%,#9C5B0B_30%,#F5DD88_56%,#9C5B0B_75%,#245B64_100%)]">

                                <div class="rounded-full bg-white w-[156px] h-[156px]  md:w-[202px] md:h-[202px] 
                                lg:w-[276px] lg:h-[276px] xl:w-[326px] xl:h-[326px] flex flex-col items-center justify-center gap-3 lg:gap-5">

                                <a href="https://ekonomika.ua/" target="_blank" rel="noopener noreferrer">
                                    <img src={Ekonomika} alt="Ekonomika" className="w-32 md:w-40 lg:w-44 xl:w-56"/>
                                </a>

                                <p className="text-center text-[#245864] text-xs lg:text-xl text-balance">бізнес/медіа бюро, до якого входять:</p>

                                </div>
                            </div>
                        </div>
                    {/* CENTER BLOCK END */}


                    {/* ЛЕВЫЙ НИЗ */}
                    <div className="md:flex">
                        <img src={BlockBg} alt="img" className="hidden md:block h-[150px] xl:h-[228px] -mr-[1px]" />

                        <a href="https://delo.ua/top100" target="_blank" rel="noopener noreferrer"
                            className="bg-[#245864] relative text-white flex flex-col justify-end gap-[5px] pb-4 pl-6 h-[150px]
                            md:flex-1 md:pl-10 md:pb-6 xl:items-center xl:justify-center xl:p-0 xl:h-[228px] xl:gap-4">
                            <img src={Top} alt="журнал «ТОП-100" className="w-12 lg:w-24" />
                            <p className="text-[10px] xl:text-right xl:text-base">
                                журнал «ТОП-100. <br /> Рейтинги найбільших»
                            </p>
                            <img src={BottomLeftBg} alt="img" className="w-14 h-16 absolute top-0 left-0 md:hidden" />
                        </a>
                    </div>
                    {/* ЛЕВЫЙ НИЗ END */}

                    {/* ПРАВЫЙ НИЗ */}
                    <div className="md:flex">
                        <a href="https://womo.ua" target="_blank" rel="noopener noreferrer"
                            className="bg-[#245864] relative text-white flex flex-col justify-end pb-4 pl-9 gap-[5px] h-[150px]
                            md:flex-1 md:items-end md:pr-10 md:pb-6 xl:items-center xl:justify-center xl:p-0 xl:h-[228px] xl:gap-4">
                            <img src={Womo} alt="Womo.ua" className="w-16 lg:w-40" />
                            <p className="text-[10px] xl:text-right xl:text-base">
                                дайджест ділової <br /> жінки Womo.ua
                            </p>
                            <img src={BottomRightBg} alt="img" className="w-14 h-16 absolute top-0 right-0 md:hidden" />
                        </a>
                        <img src={BlockBg} alt="img" className="hidden md:block md:rotate-180 h-[150px] xl:h-[228px] -ml-[1px]" />
                    </div>
                    {/* ПРАВЫЙ НИЗ END */}

                </div>

                <div>
                    <h2 className="font-bold text-xl uppercase text-[#245864] text-center mb-7
                        md:mb-11 md:text-2xl">
                        Компанія щороку проводить:
                    </h2>

                    <div className="mb-7 md:flex md:mb-8">
                        <img src={WhiteKubLeft} alt="img" className="hidden md:h-28 lg:block lg:h-36" />
                        <div className="flex flex-col gap-7 md:flex-row md:flex-1 md:gap-0
                            md:bg-white md:h-28 md:py-5 lg:h-36">
                            <a href="https://get.delo.ua/" target="_blank" rel="noopener noreferrer"
                                className="flex items-center md:flex-1 md:gap-5 md:flex-row-reverse">
                                <img src={Get} alt="delo.ua" className="w-24 mr-6 md:m-0 lg:w-32" />
                                <p className="text-base text-[#245864]">
                                    ГРАЙ ЯК ВЕЛИКИЙ. <br /> Навіть якщо малий
                                </p>
                            </a>
                            <div className="hidden md:block bg-[#228696] w-[1px] h-full mx-5 lg:mx-10"></div>
                            <a href="https://hrws.delo.ua/" target="_blank" rel="noopener noreferrer"
                                className="flex items-center md:flex-1 md:gap-5">
                                <img src={Hrws} alt="delo.ua" className="w-[105px] mr-[18px] md:m-0 lg:w-40" />
                                <p className="text-base text-[#245864] text-balance">
                                    Люди. Сенси. Форми
                                </p>
                            </a>
                        </div>
                        <img src={WhiteKubRight} alt="img" className="hidden md:h-28 lg:block lg:h-36" />
                    </div>

                    <div className="md:flex">
                        <img src={WhiteKubRight} alt="img" className="hidden md:h-28 lg:block md:rotate-180 lg:h-36" />
                        <div className="flex flex-col gap-7 md:flex-row md:flex-1 md:justify-center
                             md:gap-0 md:bg-white md:h-auto md:px-2 md:py-5 lg:h-36">
                            <a href="https://prmrfn.mmr.ua/" target="_blank" rel="noopener noreferrer"
                                className="flex items-center md:justify-end md:gap-4 ">
                                <img src={Prmrfn} alt="delo.ua" className="w-[105px] mr-[18px] md:m-0 lg:w-[124px]" />
                                
                            </a>
                            <div className="hidden md:block bg-[#228696] w-[1px] h-full mx-5"></div>

                            <a href="https://mrktng.mmr.ua/" target="_blank" rel="noopener noreferrer"
                                className="flex items-center md:gap-4">
                                <img src={Mrktng} alt="delo.ua" className="w-[105px] mr-[18px] md:m-0" />
                                <p className="text-base text-[#245864]">
                                    MRKTNG-марафон: <br /> Підкреслити головне
                                </p>
                            </a>
                            <div className="hidden md:block bg-[#228696] w-[1px] h-full mx-5"></div>

                            <a href="https://bws.delo.ua/" target="_blank" rel="noopener noreferrer"
                                className="flex items-center md:gap-4">
                                <img src={Bws} alt="delo.ua" className="w-20 mr-10 md:m-0" />
                                <p className="text-base text-[#245864] md:max-w-[230px]">
                                    БІЗНЕСИ СМІЛИВИХ
                                </p>
                            </a>

                        </div>
                        <img src={WhiteKubLeft} alt="img" className="hidden md:h-28 lg:block lg:h-36 md:rotate-180" />
                    </div>

                </div>

            </div>
        </section>
    );
};
  

export default EventOrganizers;